/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Arakan examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// import AuthService from "services/auth-service";
import CrudService from "services/cruds-service";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
// import BookingCard from "examples/Cards/BookingCard";
import i18n from "i18n";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
// import FilterProject from "./filter-article";

import StatusOnIcon from "@mui/icons-material/Wifi";
import StatusOffIcon from "@mui/icons-material/WifiOff";
import { Tooltip, IconButton, Icon } from "@mui/material";
import DefaultCell from "components/table/DefaultCell";

function Comments() {
  let { state } = useLocation();
  const { t } = i18n;

  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [limitChange, setLimitChange] = useState(false);
  const [sortVal, setSortVal] = useState(null);
  const [sortUrl, setSortUrl] = useState("&sort=-date_created");
  // const [isAdmin, setIsAdmin] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  // const [appointmentsInfo, setAppointmentsInfo] = useState(false);
  const [filterUrl, setFilterUrl] = useState(null);
  const [defaultFilterUrl, setDefaultFilterUrl] = useState("");
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const getComments = async (filUrl) => {
    const URL = `${filUrl ? `${filUrl}&page=${page}` : `&page=${page}`}`;
    // const response = await CrudService.getComments(URL);
    const response = await CrudService.getData(
      `items/comments?fields=*,user_id.first_name,user_id.last_name,project_id.translations.*${URL}`,
    );
    setData(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    getComments(`${filterUrl || ""}${sortUrl}`);
  }, [page]);

  useEffect(() => {
    getComments(`${filterUrl || ""}${sortUrl}`);
    setLimitChange(false);
  }, [limitChange]);

  useEffect(() => {
    if (page === 1) getComments(`${filterUrl || ""}${sortUrl}`);
    else if (page !== 1) setPage(1);
  }, [filterUrl, sortUrl]);

  useEffect(() => {
    setTableData(getRows(data));
  }, [data]);

  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.id,
        status: row.status,
        comment: row.comment,
        project: row.project_id?.translations[0].name,
        user: `${row.user_id?.first_name} ${row.user_id?.last_name}`,
      };
    });
    return updatedInfo;
  };

  const updateStatusHandler = async (e, data) => {
    let obj;
    if (data.status === "published") obj = { status: "draft" };
    else obj = { status: "published" };
    // await CrudService.updateCommentInfo(obj, data.id);
    await CrudService.updateItem(`items/comments/${data.id}`, obj);

    getComments(`${filterUrl || ""}${sortUrl}`);
    setNotification({
      value: true,
      text: t("statusChanged"),
    });
  };

  const dataTableData = {
    columns: [
      {
        Header: "المستخدم",
        accessor: "user",
        width: "20%",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "المشروع",
        accessor: "project",
        width: "20%",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "التعليق",
        accessor: "comment",
        width: "50%",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      // {
      //   Header: t("actions"),
      //   disableSortBy: true,
      //   accessor: "",
      //   Cell: (info) => {
      //     return (
      //       <MDBox display="flex" alignItems="center">
      //         {info.cell.row.original.status === "draft" ? (
      //           <MDButton
      //             sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
      //             variant="outlined"
      //             color={"info"}
      //             size="medium"
      //             iconOnly
      //             onClick={(e) =>
      //               updateStatusHandler(e, info.cell.row.original)
      //             }
      //           >
      //             <Icon sx={{ fontWeight: "bold" }}>wifi</Icon>
      //             &nbsp;
      //             <Tooltip title=" نشر التعليق">
      //               <span> نشر التعليق</span>
      //             </Tooltip>
      //           </MDButton>
      //         ) : (
      //           <MDButton
      //             sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
      //             variant="outlined"
      //             color={"error"}
      //             size="medium"
      //             iconOnly
      //             onClick={(e) =>
      //               updateStatusHandler(e, info.cell.row.original)
      //             }
      //           >
      //             <Icon sx={{ fontWeight: "bold" }}>wifi_off</Icon>
      //             &nbsp;
      //             <Tooltip title="إلغاء نشر التعليق">
      //               <span>إلغاء نشر التعليق</span>
      //             </Tooltip>
      //           </MDButton>
      //         )}
      //       </MDBox>
      //     );
      //   },
      // },
    ],
    rows: tableData,
  };

  return (
    <DashboardLayout>
      {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox pb={3}>
        <MDBox mb={3}>
          <Card>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium">
                {t("comments")}
              </MDTypography>
            </MDBox>

            <MDBox mt={1.5} px={3}></MDBox>
            <DataTable
              setLimitChange={setLimitChange}
              table={dataTableData}
              meta={meta}
              setPage={setPage}
              setSortVal={setSortVal}
              pageNum={page}
              isSorted={false}
            />
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Comments;
